<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.sertifika_yuklemeleri"  url="CreateProject" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<div class="content_card_content">


<!--
<ContentTable :data="data" :columns="columns" routename="Flow" deleteobjectname="flow" @dataDeleted="getData"></ContentTable>
-->

<!--<SortableTableExtended :getroute="list_route" :columns="columns" routename="Supplier"   @dataDeleted="getData" :pageble="true"></SortableTableExtended>-->

<!--
<CustomSwitch 
:initialstate="false" 
@updated="updated" 
on_icon="smartphone" 
off_icon="computer" 
on_bg_color="red"
on_value="doğru"
/>
-->

<DataTable 
:value="items"  
:lazy="true" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="limit"
dataKey="id" 
:page="page+1"
:first="first"
:rowHover="true"  
v-model:filters="filters" 
:reorderableColumns="true"
:totalRecords="totalRecords"
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@filter="onFilter($event)"
@sort="onSort($event)" 
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="globalFilterFields" 
responsiveLayout="scroll"
>
<template #header>
<div class="grid">
<div class="flex justify-content-end  align-items-center ml-2 col"> 

<span class="p-input-icon-left  ">
<i class="pi pi-search" />
<InputText v-model="searchterm" :placeholder="$store.state.languages.lang_phrases.arama" class=" p-inputtext-sm" @input="searchSupplier" :showClear="true"/>
</span>
</div>
</div>
</template>

<template #empty>
<div class="grid">
<div class="flex justify-content-center  align-items-center mx-6 col"> 
<h3 class="text-primary"> {{$store.state.languages.lang_phrases.sonuc_bulunamadi}}</h3>
</div>
</div>   
</template>
<template #loading>
<div class="loading_overlay">
<ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
Loading data. Please wait.
</div>
</template>
    <Column  :header="$store.state.languages.lang_phrases.isim" sortable field="name">
      <template #body="{data}">
        <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.supplier_id}}"><p>{{data.name}}</p></router-link>
    </template>
    </Column>
    <Column  :header="$store.state.languages.lang_phrases.tedarikci_kodu" sortable field="suppliercode">
      <template #body="{data}">
        <p>{{data.suppliercode}}</p>
    </template>
    </Column>
    <!--<Column field="flowsupplier.supplier.suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu" ></Column>-->
    <Column   
      :header="$store.state.languages.lang_phrases.marka" 
      sortable 
      field="brand_name"
      filterField="brand_name" 
      :showFilterMatchModes="false" 
      :filterMenuStyle="{ width: '14rem' }">
      <template #body="slotProps">
      <p>{{ slotProps.data.brand_name}}</p>
      </template>

      <template #filter="{ filterModel }">
          <MultiSelect v-model="filterModel.value" filter :options="brands" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
          </MultiSelect>
      </template>
      </Column>

      <Column   
      :header="$store.state.languages.lang_phrases.proje"  
      sortable 
      field="project_name"
      filterField="project_name" 
      :showFilterMatchModes="false" 
      :filterMenuStyle="{ width: '14rem' }">
      <template #body="slotProps">
      <router-link class="text-primary p-link no-underline" :to="{ name: 'SupplierProjectAllPeriods' , params: { id: slotProps.data.supplier_id,project_id:slotProps.data.project_id }}">{{ slotProps.data.project_name}}</router-link>
      </template>
      <template #filter="{ filterModel }">
          <MultiSelect v-model="filterModel.value"  filter :options="projects" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
          </MultiSelect>
      </template>
      </Column>

      <Column   
      :header="$store.state.languages.lang_phrases.donem"  
      sortable 
      field="projectperiod_name"
      filterField="projectperiod_name" 
      :showFilterMatchModes="false" 
      :filterMenuStyle="{ width: '14rem' }">
      <template #body="slotProps">
      <template v-if="slotProps.data.projectsupplier_uuid">
      <router-link class="text-primary p-link no-underline" :to="{ name: 'SupplierProject' , params: { id: slotProps.data.supplier_id,project_id:slotProps.data.projectsupplier_uuid }}">{{ slotProps.data.projectperiod_name}}</router-link>
      </template>
      <template v-else>
      <p>{{ slotProps.data.projectperiod_name}}</p>
      </template>


      </template>
      <template #filter="{ filterModel }">
          <MultiSelect filter v-model="filterModel.value"  :options="periods" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">
            <template #option="slotProps">
              {{slotProps.option.name}} - {{slotProps.option.project.name}}
          </template>
          </MultiSelect>
      </template>
      </Column>

      <Column   
      :header="$store.state.languages.lang_phrases.akis"  
      sortable 
      field="flow_name"
      filterField="flow_name" 
      :showFilterMatchModes="false" 
      :filterMenuStyle="{ width: '14rem' }">
      <template #body="slotProps">
        <template v-if="slotProps.data.projectsupplier_uuid">
          <router-link class="text-primary p-link no-underline" :to="{ name: 'SupplierProjectFlowSummary' , params: { id: slotProps.data.supplier_id,project_id:slotProps.data.projectsupplier_uuid,flow_id:slotProps.data.flowsupplier_uuid }}">{{ slotProps.data.flow_name}}</router-link>
        </template>
        <template v-else>
          <p>{{ slotProps.data.flow_name}}</p>
        </template>
      </template>
      <template #filter="{ filterModel }">
          <MultiSelect v-model="filterModel.value" filter  :options="flows" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
          </MultiSelect>
      </template>
      </Column>


      
      <Column        
      field="audit_status"  
      :header="$store.state.languages.lang_phrases.son_aktif_periyod_durumu" 
      :filterMenuStyle="{'width':'14rem'}" 
      style="min-width:12rem"
      filterField="audit_status" 
      :showFilterMatchModes="false" 
      >
      <template #filter="{ filterModel }" >    
      <MultiSelect 
      v-model="filterModel.value" 
      :options="audit_statuses"  
      placeholder="Any" 
      class="p-column-filter"
      optionLabel="text"
      optionValue="name"
      >
      <template #option="slotProps">
        <div class="flex align-items-center gap-2">
            <Tag 
            class="ml-2  mb-2 custom-chip" 
            :value="$store.state.languages.lang_phrases[slotProps.option.text]" 
            :style="'background-color:'+slotProps.option.color"
            />
        </div>
      </template>
      </MultiSelect>
      </template>
      <template #body="{data}">
      <Tag 
      class="mr-2 mt-1 custom-chip" 
      v-for=" element in audit_statuses"  
      v-show="element.name==data.audit_status"
      :value="$store.state.languages.lang_phrases[element.text]" 
      :style="'background-color:'+element.color"
      />
      </template>
      </Column>
      






      <Column 
      sortable 
      field="certificate_type" 
      :header="$store.state.languages.lang_phrases.sertifika_tipi" 
      filterField="certificate_type" 
      :showFilterMatchModes="false" 
      :filterMenuStyle="{ width: '14rem' }"
      >
      <template #filter="{ filterModel }">
        <MultiSelect v-model="filterModel.value"  filter :options="certificate_types" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
        </MultiSelect>
      </template>
      </Column>


       <Column 
       field="valid_through" 
       :header="$store.state.languages.lang_phrases.gecerlilik_tarihi" 
       sortable 
       dataType="date" 
       style="min-width: 10rem"
       filterField="valid_through" 
       :showFilterMatchModes="false" 
       :filterMenuStyle="{ width: '28rem' }">
        <template #body="{data}">
          {{ $filters.momentFormat( data.valid_through," Do MM YYYY")}}          
        </template>
        <template #filter="{ filterModel }">
          <div>
            <br/><br/>
          <Calendar v-model="filterModel.value" 
          selectionMode="range" 
          :manualInput="false" 
          showButtonBar
          inline
          panelClass="filtercalendar"
          :hideOnRangeSelection="true"/>
        </div>
      </template>
    </Column>

    <Column field="valid_through" :header="$store.state.languages.lang_phrases.kalan_sure" sortable>
          <template #body="slotProps">
              <template v-if="getValidDate(slotProps.data.valid_through)<0">
                  <Tag 
                          class="custom-chip" 
                          :value="$store.state.languages.lang_phrases.suresi_dolmus" 
                          style="background-color:#dd4b39"
                          />
              </template>
              <template v-else>
                  <p class="my-3" >{{ getValidDate(slotProps.data.valid_through)}} gün</p>
              </template>
              
          </template>
      </Column>






    <Column 
    sortable 
    field="status"  
    :header="$store.state.languages.lang_phrases.durum" 
    :filterMenuStyle="{'width':'14rem'}" 
    style="min-width:12rem"
    filterField="status" 
    :showFilterMatchModes="false" 
    >
    <template #filter="{ filterModel }" >    
    <MultiSelect 
    v-model="filterModel.value" 
    :options="statuses"  
    placeholder="Any" 
    class="p-column-filter"
    optionLabel="text"
    optionValue="name"
    >
    <template #option="slotProps">
      <div class="flex align-items-center gap-2">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases[slotProps.option.text]" 
          :style="'background-color:'+slotProps.option.color"
          />
      </div>
    </template>
    </MultiSelect>
    </template>
    <template #body="{data}">
    <Tag 
    class="mr-2 mt-1 custom-chip" 
    v-for=" element in statuses"  
    v-show="element.name==data.status"
    :value="$store.state.languages.lang_phrases[element.text]" 
    :style="'background-color:'+element.color"
    />
    </template>
    </Column>





    <Column 
    sortable 
    field="upload_reason"  
    :header="$store.state.languages.lang_phrases.yukleme_nedeni" 
    :filterMenuStyle="{'width':'14rem'}" 
    style="min-width:12rem"
    filterField="upload_reason" 
    :showFilterMatchModes="false" 
    >
    <template #filter="{ filterModel }" >    
    <MultiSelect 
    v-model="filterModel.value" 
    :options="upload_reasons"  
    placeholder="Any" 
    class="p-column-filter"
    optionLabel="text"
    optionValue="name"
    >
    <template #option="slotProps">
      <div class="flex align-items-center gap-2">
          <Tag 
          class="ml-2  mb-2 custom-chip" 
          :value="$store.state.languages.lang_phrases[slotProps.option.text]" 
          :style="'background-color:'+slotProps.option.color"
          />
      </div>
    </template>
    </MultiSelect>
    </template>
    <template #body="{data}">
    <Tag 
    class="mr-2 mt-1 custom-chip" 
    v-for=" element in upload_reasons"  
    v-show="element.name==data.upload_reason"
    :value="$store.state.languages.lang_phrases[element.text]" 
    :style="'background-color:'+element.color"
    />
    </template>
    </Column>














   <Column field="updated_at" :header="$store.state.languages.lang_phrases.eklenme_tarihi" sortable dataType="date" style="min-width: 8rem">
        <template #body="{data}">
            {{ $filters.momentFormat( data.created_at," Do MM YYYY hh:mm")}}
        </template>
    </Column>

    <Column field="updated_at" :header="$store.state.languages.lang_phrases.guncelleme_tarihi" sortable dataType="date" style="min-width: 8rem">
        <template #body="{data}">
            {{ $filters.momentFormat( data.updated_at," Do MM YYYY hh:mm")}}
        </template>
    </Column>

    


    <Column 
      sortable 
      field="user_name" 
      :header="$store.state.languages.lang_phrases.islem_yapan" 
      filterField="user_name" 
      :showFilterMatchModes="false" 
      :filterMenuStyle="{ width: '14rem' }"
      >
      <template #filter="{ filterModel }">
        <MultiSelect v-model="filterModel.value"  filter :options="users" optionLabel="name" optionValue="id" placeholder="Any" class="p-column-filter">        
        </MultiSelect>
      </template>
      </Column>


    <Column>
      <template #body="{data}">
        <router-link :to="{ name: 'IntermediateFlowsupplierPage' , params:{flowsupplier_uuid:data.flowsupplier_uuid}}" target="_blank" >
          <Button label="Görüntüle"  class="p-button-white  p-button-sm rightmargin"  />
      </router-link>
      </template>

    </Column>
</DataTable>











</div>





</div>







</div>
</template>

<script>
import moment from "moment";
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import TableTag from "../../components/pagecomponents/TableTag"
export default {

  name: 'CertificateUploads',
  components:{TableTag},
  data () {
    return {
      loading: true,  
      items:[],
      list_route:"latest_nonconformities",
      page:0,
      limit:10,   
      first:0, 
      totalRecords:0, 
      sort_column:"updated_at",
      sort_order:"desc", 
      searchterm:"",
      intervalobj:null,
      brands:[],
      projects:[],
      certificate_types:[],
      periods:[],
      flows:[],
      users:[],
      exemption_certificates:[],
      selected_brands:[],
      selected_projects:[],
      selected_certificate_types:[],
      selected_users:[],
      selected_flows:[],
      selected_statuses:[],
      selected_upload_reasons:[],
      selected_periods:[],
      selected_audit_statuses:[],
      filters:{
        brand_name: { value: [], matchMode: FilterMatchMode.IN },
        project_name: { value: [], matchMode: FilterMatchMode.IN },
        projectperiod_name: { value: [], matchMode: FilterMatchMode.IN },
        flow_name: { value: [], matchMode: FilterMatchMode.IN },     
        auditor_name: { value: [], matchMode: FilterMatchMode.IN },        
        status: { value: [], matchMode: FilterMatchMode.IN },            
        upload_reason: { value: [], matchMode: FilterMatchMode.IN },          
        audit_status: { value: [], matchMode: FilterMatchMode.IN },       
        flow_type: { value: [], matchMode: FilterMatchMode.IN },   
        certificate_type: { value: [], matchMode: FilterMatchMode.IN },
        user_name: { value: [], matchMode: FilterMatchMode.IN },
        valid_through: { value: null, matchMode: FilterMatchMode.IN },
      },
      statuses:[
        {
          name:"uploaded",
          color:"#a855f7",
          text:"degerlendirmede",
        },
        {
          name:"rejected",
          color:"#dd4b39",
          text:"reddedildi",
        },
        {
          name:"accepted",
          color:"#4dc247",
          text:"kabul_edildi",
        },
      ],
      upload_reasons:[
        {
          name:"upload",
          color:"#a855f7",
          text:"beyan",
        },
        {
          name:"exemption",
          color:"#4dc247",
          text:"muafiyet",
        },
      ],
      audit_statuses:[
        {
          name:"awaiting_schedule",
          color:"#352f8d",
          text:"planlama_bekliyor",
        },
        {
          name:"scheduled",
          color:"#4dc247",
          text:"planlandi",
        },
        {
          name:"started",
          color:"#dd4b39",
          text:"baslandi",
        },
        {
          name:"under_review",
          color:"#ff6600",
          text:"degerlendirmede",
        },
        {
          name:"finished",
          color:"#4dc247",
          text:"tamamlandi0",
        },
        {
          name:"exempt",
          color:"#10b981",
          text:"muaf",
        },
        {
          name:"deleted",
          color:"#661814",
          text:"iptal_edildi",
        },
      ],
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
      },      
      {
        type:"text",
        field:"suppliercode",
        header:"tedarikci_kodu",
        hide_on_mobile:true,
      },
      {
        type:"text",
        field:"brand_name",
        header:"marka",
        hide_on_mobile:true,
      },
      {
        type:"text",
        field:"flow_name",
        header:"akis",
        hide_on_mobile:true,
      }, 
      {
        type:"text",
        field:"certificate_type",
        header:"sertifika_tipi",
        hide_on_mobile:true,
      }, 
      {
        type:"pill",
        field:"status",
        header:"durum",
        options:[
          {
            name:"pending",
            color:"#a855f7",
            text:"degerlendirmede",
          },
          {
            name:"rejected",
            color:"#dd4b39",
            text:"reddedildi",
          },
          {
            name:"approved",
            color:"#4dc247",
            text:"tamamlandi",
          },
          {
            name:"open",
            color:"#ff6600",
            text:"beklemede",
          },
        ],
      },     
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:false,
      },

      ]
    }
  },
  computed:{
    globalFilterFields()
    {
        let items = this.columns.map((item)=>{return item.field})
        return items
    },
  },
  mounted()
  {
    this.getBrands()
  },
  methods:{
    updated(data)
    {
      console.log(data)
    },
    searchSupplier()
    {
      clearInterval(this.intervalobj);
        this.intervalobj = setInterval(()=>{
            this.page = 0
            this.getData()
            clearInterval(this.intervalobj);
        },1000)

    },
    getValidDate(data)
    {        
        if(data)
        {
            let today = moment()
            let date = moment(data)
            let diff = date.diff(today, 'days')
            return diff
        }
        return 0
    },
    async getBrands()
    {
      this.loading = true
      let roles = this.$store.state.auth.user.userroles.map(item=> item.name)
      if(roles.includes("brand"))
      {
        this.brands = await this.generalApiGetWithoutLoader("brands_for_brandmanager") 
      }
      if(roles.includes("planner"))
      {
        this.brands = await this.generalApiGetWithoutLoader("brands_for_planner") 
      }

      if(roles.includes("admin") || roles.includes("technical_auditor"))
      {
        this.brands = await this.generalApiGetWithoutLoader("brands") 
      }
      console.log(this.brands)
      
      this.getProjects()
    },
    async getProjects()
    { 
      let selected_brands = []
      if(this.selected_brands.length)
      {
        selected_brands = this.selected_brands
      }
      else
      {
        selected_brands = this.brands.map(item=>item.id)
      }      
      let arr = JSON.stringify(selected_brands)
      this.projects = await this.generalApiGetWithoutLoader("auditable_projects?selected_brands="+arr) 
      await this.getPeriods()
      
    },
    async getPeriods()
    { 
      console.log("getPeriods")
      let selected_projects = []
      if(this.selected_projects.length)
      {
        selected_projects = this.selected_projects
      }
      else
      {
        selected_projects = this.projects.map(item=>item.id)
      }

      let arr = JSON.stringify(selected_projects)
      let periods = await this.generalApiGetWithoutLoader("auditable_periods?selected_projects="+arr)
      this.periods = periods 

      await this.getCertificateTypes()
      
    },
    async getCertificateTypes()
    { 
      this.certificate_types = await this.generalApiGetWithoutLoader("certificatetypes") 
      this.users = await this.generalApiGetWithoutLoader("users") 
      this.exemption_certificates = await this.generalApiGetWithoutLoader("exemption_certificates") 

      await this.getFlows()
      
    },
    async getFlows()
    {

      let selected_projects = []
      if(this.selected_projects.length)
      {
        selected_projects = this.selected_projects
      }
      else
      {
        selected_projects = this.projects.map(item=>item.id)
      }

      selected_projects = JSON.stringify(selected_projects)
      
      //this.selected_flows = []
      this.flows = await this.generalApiGetWithoutLoader("auditable_flows?flowtype=audit&selected_projects="+selected_projects)
      this.getData()
      
    },
    async getData()
    {      

      //let data = await this.generalApiGet("latest_nonconformities") 

      this.loading = true
      let all_filters = this.sanitizeArray(this.filters)

      all_filters = JSON.stringify(all_filters)

      let data = await this.generalApiGetWithoutLoader("latest_certificate_uploads/"+this.page+"/"+this.limit+"?sort_column="+this.sort_column+"&sort_order="+this.sort_order+"&all_filters="+all_filters+"&searchterm="+this.searchterm)
        
      for(let dataitem of data.data)
      {
        let projectsupplier_uuid = await this.generalApiGetWithoutLoader("planned_objects/projectsupplier_uuid/"+dataitem.project_id+"/"+dataitem.supplier_id+"/"+dataitem.projectperiod_id)
        if(projectsupplier_uuid)
        {
          dataitem.projectsupplier_uuid = projectsupplier_uuid
        } 
        if(this.exemption_certificates.includes(dataitem.certificatetype_id))
        {
          dataitem.upload_reason = "exemption"
        }
        else
        {
          dataitem.upload_reason = "upload"
        }
        
      }
      console.log(data)
      
      this.items = await data.data
      this.totalRecords = await data.meta.total       
      
      this.loading = false
      //await this.$store.dispatch('flows/setFlows',this.data)
    },
    onPage(event)
    {
        this.page = event.page
        this.getData()
        console.log(event)        
    },

    onFilter(event)
    {
      console.log("filter")
      console.log(event)
      this.page = 0
      this.selected_projects = []
      this.selected_flows = []
      this.selected_brands = []

      if(event.filters.brand_name.value && event.filters.brand_name.value.length)
      {        
        this.selected_brands = event.filters.brand_name.value
      }
      else
      {        
        this.selected_brands = []
      }

      if(event.filters.project_name.value && event.filters.project_name.value.length)
      {
        
        this.selected_projects = event.filters.project_name.value
      }
      else
      {
        this.selected_projects = []
      }
      if(event.filters.projectperiod_name.value && event.filters.projectperiod_name.value.length)
      {
        
        this.selected_periods = event.filters.projectperiod_name.value
      }
      else
      {
        this.selected_periods = []
      }

      if(event.filters.flow_name.value && event.filters.flow_name.value.length)
      {       
        this.selected_flows = event.filters.flow_name.value
      }
      else
      {
        this.selected_flows = []
      }

      if(event.filters.certificate_type.value && event.filters.certificate_type.value.length)
      {       
        this.selected_certificate_types = event.filters.certificate_type.value
      }
      else
      {
        this.selected_certificate_types = []
      }

      if(event.filters.user_name.value && event.filters.user_name.value.length)
      {       
        this.selected_users = event.filters.certificate_type.value
      }
      else
      {
        this.selected_users = []
      }

      if(event.filters.status.value && event.filters.status.value.length)
      {        
        this.selected_statuses = event.filters.status.value
      }
      else
      {
        this.selected_statuses = []
      }

      if(event.filters.upload_reason.value && event.filters.upload_reason.value.length)
      {        
        this.selected_upload_reasons = event.filters.upload_reason.value
      }
      else
      {
        this.selected_upload_reasons = []
      }

      if(event.filters.audit_status.value && event.filters.audit_status.value.length)
      {        
        this.selected_audit_statuses = event.filters.audit_status.value
      }
      else
      {
        this.selected_audit_statuses = []
      }

      
      if(event.filters.flow_type.value && event.filters.flow_type.value.length)
      {        
        this.selected_types = event.filters.flow_type.value
      }
      else
      {
        this.selected_types = []
      }

      this.getBrands() 
    },
    onSort(event)
    {
        console.log(this.globalFilterFields)
        this.sort_column = event.sortField
        if(event.sortOrder===1)
        {
            this.sort_order = "asc"
        }
        else
        {
            this.sort_order = "desc"
        }
        this.getData()

    },
    async goToProjectSummaryPage(data)
    {
      //let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+uuid)
      console.log(data)
      //return false
      let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+data.flowsupplier_uuid)

      await this.$router.push({ name: 'SupplierProjectFlowSummary',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid,flow_id:data.flowsupplier_uuid} })

      return false
      await this.$router.push({ name: 'SupplierFlowNonconformity',params:{id:data.supplier_id,nonconformity_id:data.nonconformity_id} })
    },
    
  }
};
</script>

<style lang="css" scoped>
  .loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
</style>